import { useEffect } from "react";

const set = (selector, attr, value, create) => {
  let el = document.head.querySelector(selector);
  if (!el && create) { el = create(); document.head.appendChild(el); }
  if (el) el.setAttribute(attr, value);
};

/** Per-route title / description / canonical so no two pages share meta. */
export function useSeo({ title, description, path, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      set('meta[name="description"]', "content", description,
        () => Object.assign(document.createElement("meta"), { name: "description" }));
      set('meta[property="og:description"]', "content", description,
        () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; });
    }
    if (title) {
      set('meta[property="og:title"]', "content", title,
        () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; });
    }
    const url = window.location.origin + (path || window.location.pathname);
    set('link[rel="canonical"]', "href", url,
      () => Object.assign(document.createElement("link"), { rel: "canonical" }));
    set('meta[property="og:url"]', "content", url,
      () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; });
    set('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow",
      () => Object.assign(document.createElement("meta"), { name: "robots" }));
  }, [title, description, path, noindex]);
}

export default useSeo;
